var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96003(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3,.cls-4{fill:none;}.cls-2{stroke:#6f6e6f;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-3{stroke:#706e70;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.62,51.43H28.83M38.5,39.18H5.62M68,52.14a32.54,32.54,0,0,1,10,3c-2.74,1.51-9.3,3.7-19.48,3.7a6.13,6.13,0,0,0,0,12.25c22.72,0,32.89-8,32.89-15.95,0-6.73-7.32-13.51-23.4-15.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68,28.48V55c0,2-6.61,3.56-14.76,3.56-1.48,0-2.91-.06-4.26-.15M38.5,28.48V51.35M68,50.18c0,1.63-6.61,2.94-14.76,2.94-2,0-4-.08-5.73-.23m-9-2.71c0,.46.54.89,1.47,1.28M38.5,39.33c0,1.62,6.61,2.94,14.77,2.94S68,41,68,39.33M38.5,44.76c0,1.62,6.61,2.94,14.77,2.94S68,46.38,68,44.76M38.5,33.91c0,1.62,6.61,2.93,14.77,2.93S68,35.53,68,33.91M53.27,25.54c-8.16,0-14.77,1.32-14.77,2.94s6.61,2.94,14.77,2.94S68,30.1,68,28.48,61.42,25.54,53.27,25.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49,54.16V64.7c0,2-6.61,3.56-14.76,3.56S19.49,66.67,19.49,64.7V54.16m0,5.43c0,1.62,6.61,2.93,14.76,2.93S49,61.21,49,59.59M34.25,51.23c-8.15,0-14.76,1.31-14.76,2.93S26.1,57.1,34.25,57.1,49,55.79,49,54.16,42.4,51.23,34.25,51.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 96,
    height: 96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96003);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_003.9df97aeef145d45df034128d3aa5d526.svg";
export { ForwardRef as ReactComponent };